<template>
	<div class="secondpage">
		<div class="title_top">
			<el-row :gutter="20">
				<el-col :span="16" :offset="4">
					<div class="secondpage_con">
						<h2>关于神寻</h2>
						<p>东方集市APP是神寻科技旗下创立的本地生活平台，主营涵盖了餐饮、外卖、生鲜零售、酒店、休闲娱乐等多个品类的线上服务平台，商家免费入驻平台获取更多的线上流量与推广渠道。平台与银联、商家多方合作、整合多方面资源帮助商家获客更轻松。资金安全由中国银联提供技术支持与监管，没有资金风险，开店更无忧。</p>
						<h2>关于家乡</h2>
						<p>我们始终认为，我们接受高等教育的目的，是为了帮助家乡摆脱贫困，而不是为了我们摆脱贫困的家乡。如果，有个新的商业模式，能为三四线城市提供大量稳定的工作岗位，能让更多年轻人有机会、有条件留在家乡，用满腔热血去建设家乡，让人才遍布祖国大地，让各个城市百花齐放，而不是全部聚集到一线城市。整个社会的格局，会不会就不一样了。</p>
							<h2>关于资本</h2>
							<p>近年来，一些知名互联网企业，以庞大的资本垄断了市场，却与民争利，吸民血髓，抢民生计，触动国家的根基而不自知。虽然市值千万亿，但长远看来，却是摇摇欲坠。</p>
							<p>“与天下同利者，天下持之；擅天下之利者，天下谋之。天下所谋，虽立必隳；天下所持，虽高不危。故曰：高安在乎同利。”——管仲《管子·版法解》（春秋）《六韬·卷一》（战国）</p>
							<p>同利，是我们的出发点，也是我们不变的核心。</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 内容 -->
		<!-- 布局 -->
		<el-row>
      <el-col :xs="24">
        <div class="box3">
          <el-row>
            <el-col :span="20" :offset="2">
              <p class="box3_title">我们的<span>团队风采</span></p>
            </el-col>
            <el-col :span="20" :offset="2">
              <p class="box3_content">
                凝心聚力，务实笃行。
              </p>
            </el-col>
            <el-col :span="20" :offset="2" class="hidden-xs-only">
              <div class="animated elcarouselbox">
                <el-carousel
                  autoplay
                  class="box3_carousel"
                  :interval="50000"
                  type="card"
                  height="500px"
                >
                  <el-carousel-item v-for="item in imageUrls" :key="item.id">
                    <el-row
                      ><img
                        width="100%"
                        :src="item.url"
                        alt=""
						
                    /></el-row>
                    <el-row>
                      <!-- <p><span>何淼</span><span>/工程师</span></p>
                      <p>
                        2010年获得一系列的荣誉证书，担任协会的会长，2010年获得一系列的荣誉证书
                      </p> -->
                    </el-row>
                    <el-row>
                      <!-- <el-button round>
                        <router-link :to="{ path: '/about', query: { id: 1 } }"
                          >了解详情</router-link
                        >
                      </el-button> -->
                    </el-row>
                  </el-carousel-item>
                  </el-carousel>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				imageUrls: [
        {
			id:'1',
          url:require("../assets/22.jpg"),
        },
        {
			id:'2',
          url:require("../assets/11.jpg"),
        },
        {
			id:'3',
          url:require("../assets/33.jpg"),
        },
        {
			id:'4',
          url:require("../assets/44.jpg"),
        },
        {
			id:'5',
          url:require("../assets/55.jpg"),
        },
      ],
				workTask: []
			};
		},
		created() {
			this.workTask = this.$route.query.id
			console.log(this.workTask)
		},
		beforeMount: function() { //挂载前状态
			
		}

	}

</script>

<style scoped>
	* {

		color: #000000;
	}

	.box3 .box3_title {
  font-size: 30px;
  font-weight: 600;
  color: #000000;
}

.box3 .box3_title span {
  color: #cf9236;
}



	.title_top {

		width: 100%;
		overflow: hidden;
		margin: 0;
		color: #000000;
		background: url(../assets/1587_jgzynhtp.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.secondpage_con {
		margin: 120px auto;
		
	}

	.secondpage_con h1,
	.secondpage_con p,.secondpage_con h2{
		color: #FFFFFF;
	}

	.el-row {
		/* margin-top: 60px ; */
	}

	.lefttitle {
		text-align: left;
	}

	.yunduanfuwu {
		text-align: left;
		width: 100%;
		overflow: hidden;
		padding-top: 50px;
		padding-bottom: 50px;
		color: #FFFFFF;
		background: url(../assets/1587_jh5pkdw8.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.yunduanfuwu h1,
	.yunduanfuwu p {
		color: #FFFFFF;
	}

	.yunduanfuwu button {
		color: #0286e6;
	}


	.el-carousel__item {
		background-color: #FFFFFF;
		box-shadow: 3px 3px 10px #f5f5f5;

	}

	.el-carousel__item .el-button {
		border-color: #249dc3;
		color: #249dc3;
	}
	.hezuohuoban{
		width: 100%;
		height: 100%;
		background-color: rgb(248, 248, 248);
	}
</style>


// WEBPACK FOOTER //
// src/components/about.vue